import { publicUrl } from '@/lib/siteUrl';

export const LOCAL_ALBUMS = [
  {
    id: 'concert-noel-2025',
    title: 'Concert de Noël 2025',
    date: '2025-12-15',
    description: 'Une soirée magique sous les lumières de Noël.',
    coverImage: publicUrl('/albums/concert-noel-2025/concert.jpg'),
    zipPath: publicUrl('/albums/zip/concert-noel-2025.zip'),
    photos: [
      { url: publicUrl('/albums/concert-noel-2025/concert.jpg'), caption: 'L\'orchestre lors du concert' },
      { url: publicUrl('/albums/concert-noel-2025/img_2616.jpg') },
      { url: publicUrl('/albums/concert-noel-2025/img_2619.jpg') },
    ]
  },
  {
    id: 'metz-2025',
    title: 'Metz 2025',
    date: '2025-02-10',
    description: 'Excursion culturelle à la découverte de Metz et sa cathédrale.',
    coverImage: publicUrl('/albums/metz-2025/img_3009.jpg'),
    zipPath: publicUrl('/albums/zip/metz-2025.zip'),
    photos: [
      { url: publicUrl('/albums/metz-2025/img_3004.jpg') },
      { url: publicUrl('/albums/metz-2025/img_3009.jpg') },
      { url: publicUrl('/albums/metz-2025/img_3021.jpg') },
    ]
  },
  {
    id: 'gand-2023',
    title: 'Gand 2023',
    date: '2023-05-20',
    description: 'Balade le long des canaux de la cité médiévale.',
    coverImage: publicUrl('/albums/gand-2023/img_1608.jpg'),
    zipPath: publicUrl('/albums/zip/gand-2023.zip'),
    photos: [
      { url: publicUrl('/albums/gand-2023/img_1605.jpg') },
      { url: publicUrl('/albums/gand-2023/img_1608.jpg') },
      { url: publicUrl('/albums/gand-2023/img_1628.jpg') },
    ]
  },
  {
    id: 'treves-2019',
    title: 'Trèves 2019',
    date: '2019-09-15',
    description: 'Voyage dans le temps à la découverte des vestiges romains.',
    coverImage: publicUrl('/albums/treves-2019/Capture d’écran 2026-03-15 à 16.02.06.jpg'),
    zipPath: publicUrl('/albums/zip/treves-2019.zip'),
    photos: [
      { url: publicUrl('/albums/treves-2019/Capture d’écran 2026-03-15 à 16.00.10.jpg') },
      { url: publicUrl('/albums/treves-2019/Capture d’écran 2026-03-15 à 16.00.24.jpg') },
      { url: publicUrl('/albums/treves-2019/Capture d’écran 2026-03-15 à 16.00.36.jpg') },
      { url: publicUrl('/albums/treves-2019/Capture d’écran 2026-03-15 à 16.01.03.jpg') },
      { url: publicUrl('/albums/treves-2019/Capture d’écran 2026-03-15 à 16.01.13.jpg') },
      { url: publicUrl('/albums/treves-2019/Capture d’écran 2026-03-15 à 16.01.39.jpg') },
      { url: publicUrl('/albums/treves-2019/Capture d’écran 2026-03-15 à 16.01.54.jpg') },
      { url: publicUrl('/albums/treves-2019/Capture d’écran 2026-03-15 à 16.02.06.jpg') },
    ]
  }
];
